import { createFileRoute } from '@tanstack/react-router';

import { ReportingOverview } from 'component/partial/Reporting/ReportingOverview';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/reporting/')({
  component: ReportingIndexRoute,
});

function ReportingIndexRoute() {
  return <ReportingOverview />;
}
